const toast = document.querySelector('#toast');
const codeButton = document.querySelector('#copy-code');

function showToast(message) {
  toast.textContent = message;
  toast.classList.add('show');
  window.setTimeout(() => toast.classList.remove('show'), 2200);
}

codeButton?.addEventListener('click', async () => {
  const code = codeButton.dataset.code;
  try {
    await navigator.clipboard.writeText(code);
    showToast(`Code copied: ${code}`);
  } catch {
    showToast(`Use code: ${code}`);
  }
});

const signalForm = document.querySelector('#signal-form');

if (signalForm) {
  signalForm.dataset.startedAt = Date.now().toString();

  signalForm.addEventListener('submit', async (event) => {
    event.preventDefault();

    const endpoint = signalForm.dataset.endpoint?.trim();
    const submitButton = signalForm.querySelector('button[type="submit"]');
    const formNote = signalForm.querySelector('.form-note');
    const originalButton = submitButton.innerHTML;

    formNote.classList.remove('is-success', 'is-error');

    if (!endpoint || !/^https:\/\/script\.google\.com\/(?:a\/macros\/[^/]+\/|macros\/)s\/[^/]+\/exec$/.test(endpoint)) {
      formNote.textContent = 'Submission setup is not complete yet. Please email team@enduraphin.com.';
      formNote.classList.add('is-error');
      return;
    }

    const payload = Object.fromEntries(new FormData(signalForm).entries());
    payload.startedAt = signalForm.dataset.startedAt;

    submitButton.disabled = true;
    submitButton.textContent = 'Submitting…';
    signalForm.setAttribute('aria-busy', 'true');

    try {
      await fetch(endpoint, {
        method: 'POST',
        mode: 'no-cors',
        cache: 'no-store',
        headers: { 'Content-Type': 'text/plain;charset=utf-8' },
        body: JSON.stringify(payload)
      });

      signalForm.reset();
      signalForm.dataset.startedAt = Date.now().toString();
      formNote.textContent = 'Demand signal received. Thank you for adding your voice.';
      formNote.classList.add('is-success');
      showToast('Demand signal received');
    } catch {
      formNote.textContent = 'We could not submit your response. Please try again or email team@enduraphin.com.';
      formNote.classList.add('is-error');
    } finally {
      submitButton.disabled = false;
      submitButton.innerHTML = originalButton;
      signalForm.removeAttribute('aria-busy');
    }
  });
}

const videoModal = document.querySelector('#field-video-modal');
const fieldVideo = document.querySelector('#field-video');
const openVideoButton = document.querySelector('#open-field-video');
const closeVideoButton = videoModal?.querySelector('.video-close');

function openVideo() {
  if (!videoModal) return;
  videoModal.hidden = false;
  document.body.classList.add('modal-open');
  closeVideoButton?.focus();
}

function closeVideo() {
  if (!videoModal) return;
  videoModal.hidden = true;
  document.body.classList.remove('modal-open');
  fieldVideo?.pause();
  openVideoButton?.focus();
}

openVideoButton?.addEventListener('click', openVideo);
videoModal?.querySelectorAll('[data-close-video]').forEach((control) => control.addEventListener('click', closeVideo));
document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape' && videoModal && !videoModal.hidden) closeVideo();
});

const unitSalesModal = document.querySelector('#unit-sales-modal');
const openUnitSalesButton = document.querySelector('#open-unit-sales');
const closeUnitSalesButton = unitSalesModal?.querySelector('.video-close');

function openUnitSales() {
  if (!unitSalesModal) return;
  unitSalesModal.hidden = false;
  document.body.classList.add('modal-open');
  closeUnitSalesButton?.focus();
}

function closeUnitSales() {
  if (!unitSalesModal) return;
  unitSalesModal.hidden = true;
  document.body.classList.remove('modal-open');
  openUnitSalesButton?.focus();
}

openUnitSalesButton?.addEventListener('click', openUnitSales);
unitSalesModal?.querySelectorAll('[data-close-unit-sales]').forEach((control) => control.addEventListener('click', closeUnitSales));
document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape' && unitSalesModal && !unitSalesModal.hidden) closeUnitSales();
});
